export interface Token {
  address: string;
  symbol: string;
  name: string;
  decimals: number;
  chainId: number;
  logoURI?: string;
}

// Sepolia test tokens
export const SEPOLIA_TOKENS: Token[] = [
  {
    address: "0xFFF9976782D46CC05630D1f6EbaB18Bfc4d34eF6",
    symbol: "WETH",
    name: "Wrapped Ether",
    decimals: 18,
    chainId: 11155111,
  },
  {
    address: "0x4C75e28e43F7BA8460122E6F1C2F62242d5fdaeE",
    symbol: "KVH",
    name: "Kavachswap",
    decimals: 18,
    chainId: 11155111,
  },
];

export const MAINNET_TOKENS: Token[] = [
  {
    address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    symbol: "WETH",
    name: "Wrapped Ether",
    decimals: 18,
    chainId: 1,
  },
  {
    address: '0xD13379d75D35075119Ac7c8C6595BCA43796D42E',
    symbol: 'KVH',
    name: 'Kavachswap',
    decimals: 18,
    chainId: 1,
    logoURI: 'https://moccasin-holy-ptarmigan-404.mypinata.cloud/ipfs/bafybeibhbkop7ugpfh4qpeoyp3dnrslhkx3gcicaism75rifuf6qfrajgm',
  },
  {
    address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    symbol: "USDC",
    name: "USD Coin",
    decimals: 6,
    chainId: 1,
  },
  {
    address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
    symbol: "USDT",
    name: "Tether USD",
    decimals: 6,
    chainId: 1,
  },
];

export const TOKENS_BY_CHAIN: Record<number, Token[]> = {
  1: MAINNET_TOKENS,
  11155111: SEPOLIA_TOKENS,
};

export interface WalletTokenInfo {
  address: string
  symbol: string
  name: string
  decimals: number
  image: string
}

const WALLET_TOKENS_BY_CHAIN: Record<number, WalletTokenInfo | null> = {
  1: {
    address: '0xD13379d75D35075119Ac7c8C6595BCA43796D42E',
    symbol: 'KVH',
    name: 'Kavachswap',
    decimals: 18,
    image: 'https://moccasin-holy-ptarmigan-404.mypinata.cloud/ipfs/bafybeibhbkop7ugpfh4qpeoyp3dnrslhkx3gcicaism75rifuf6qfrajgm',
  },
  11155111: null,
}

export function getWalletTokenByChain(chainId: number): WalletTokenInfo | null {
  return WALLET_TOKENS_BY_CHAIN[chainId] ?? null
}

export function getTokensByChain(chainId: number): Token[] {
  return TOKENS_BY_CHAIN[chainId] ?? [];
}

export const NATIVE_ETH: Token = {
  address: "0x0000000000000000000000000000000000000000",
  symbol: "ETH",
  name: "Ether",
  decimals: 18,
  chainId: 0,
};
